import React, { useEffect } from 'react';
import { generatePath, useHistory, Link, useRouteMatch, Route, Switch } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Box, Breadcrumbs } from '@mui/material';
import { DirectionsCar as DirectionsCarIcon, Home as HomeIcon, ViewList as ViewListIcon } from '@mui/icons-material';
import { useIntl } from 'react-intl';
import FoodDonorMobileSchedule from './Components/FoodDonorMobileSchedule';
import FoodDonorMobileRecentRescues from './Components/FoodDonorMobileRecentRescues';
import {
  StyledRescuerBreadcrumb,
  StyledRescuerTextBreadcrumb,
} from '../../rescuerDashboard/rescuerDashboardMobile/Components/StyledRescuerBreadcrumb';
import routes from '../../../routes';
import { Roles } from '../../../models/roles';
import useActiveUser from '../../../hooks/useActiveUser';
import { getUserRolesInCurrentlySelectedSite } from '../../../services/auth';
import MobileWrapper from '../../../components/Common/MobileBottomNavWrapper';
import { fetchSiteFoodDonorRescues } from '../../../actions/sites';
import useActiveSite from '../../../hooks/useActiveSite';

const paths = [
  generatePath(routes.mobileDashboardFoodDonorSchedule, { tab: 'upcoming-rescues' }),
  generatePath(routes.mobileDashboardFoodDonorSchedule, { tab: 'recent-rescues' }),
];

const FoodDonorMobileScheduleBreadcrumb = () => {
  const { formatMessage } = useIntl();

  return (
    <Box boxShadow={0}>
      <Breadcrumbs aria-label="breadcrumb">
        <StyledRescuerBreadcrumb
          component={Link}
          to={generatePath(routes.mobileDashboard)}
          label={formatMessage({ id: 'breadcrumbs.home' })}
          icon={<HomeIcon style={{ color: '#fff' }} fontSize="small" />}
        />
        <StyledRescuerTextBreadcrumb
          component="a"
          href="#"
          label={formatMessage({ id: 'breadcrumbs.receiver-schedule' })}
        />
      </Breadcrumbs>
    </Box>
  );
};

const iconSx = {
  fontSize: '1.8rem',
};

const FoodDonorMobileScheduleContainer = () => {
  const dispatch = useDispatch();
  const site = useActiveSite();
  const { url } = useRouteMatch();
  const history = useHistory();
  const activeUser = useActiveUser();
  const userRoles = getUserRolesInCurrentlySelectedSite(activeUser);
  const rolesWithAccess = userRoles.filter(
    (role) =>
      role.role_name === Roles.DonorAdmin ||
      role.role_name === Roles.DonorStaff ||
      role.role_name === Roles.DonorLocationAdmin ||
      role.role_name === Roles.DonorLocationStaff
  );
  const foodDonorId = rolesWithAccess[0]?.donor_location_id;
  const { formatMessage } = useIntl();

  useEffect(() => {
    if (site?.id && foodDonorId) {
      dispatch(fetchSiteFoodDonorRescues(site.id, foodDonorId));
    }
  }, [site, foodDonorId]);

  const getActiveTab = () => {
    const path = paths.indexOf(url);

    return Math.max(0, path); // no negatives numbers
  };

  const bottomTabs = [
    {
      label: formatMessage({ id: 'rescuer-my-rescues-mobile.bottom-navigation.upcoming' }),
      url: paths[0],
      icon: <ViewListIcon sx={iconSx} />,
      testId: 'foodDonorMobileScheduleTab0',
    },
    {
      label: formatMessage({ id: 'rescuer-my-rescues-mobile.bottom-navigation.recent' }),
      url: paths[1],
      icon: <DirectionsCarIcon sx={iconSx} />,
      testId: 'foodDonorMobileScheduleTab1',
    },
  ];

  if (!rolesWithAccess.length) {
    return history.push(routes.index);
  }

  return (
    <MobileWrapper
      containerId="food-donor-dashboard-mobile-schedule"
      breadcrumb={<FoodDonorMobileScheduleBreadcrumb />}
      activeTab={getActiveTab()}
      bottomTabs={bottomTabs}
      pageContent={
        <Switch>
          <Route
            path={[generatePath(routes.mobileDashboardFoodDonorSchedule), paths[0]]}
            exact
            render={() => <FoodDonorMobileSchedule foodDonorId={foodDonorId} />}
          />
          <Route path={paths[1]} exact render={() => <FoodDonorMobileRecentRescues foodDonorId={foodDonorId} />} />
        </Switch>
      }
    />
  );
};

export default FoodDonorMobileScheduleContainer;
